"use strict";

exports.__esModule = true;
exports.DetailsSubSection = DetailsSubSection;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Heading = require("../Heading");
var _Theme = require("../../Theme");
var _excluded = ["heading", "content", "muted", "level"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var SubSection = _styledComponents["default"].div.withConfig({
  displayName: "DetailsSubSection__SubSection",
  componentId: "sc-k6tjit-0"
})(["display:flex;flex-direction:column;margin-top:0.5rem;opacity:", ";"], function (props) {
  return props.muted ? "0.2" : "1";
});
var SubSectionHeading = (0, _styledComponents["default"])(_Heading.Heading).withConfig({
  displayName: "DetailsSubSection__SubSectionHeading",
  componentId: "sc-k6tjit-1"
})(["margin:0 0 0.3rem;"]);
var SubSectionContent = _styledComponents["default"].div.withConfig({
  displayName: "DetailsSubSection__SubSectionContent",
  componentId: "sc-k6tjit-2"
})(["display:flex;font-size:16px;justify-content:flex-start;flex-wrap:wrap;padding-bottom:0.1rem;align-items:center;font-size:", ";& .bp6-form-group{width:100%;}"], (0, _Theme.val)("fontSizeSmall"));
function DetailsSubSection(props) {
  var heading = props.heading,
    content = props.content,
    _props$muted = props.muted,
    muted = _props$muted === void 0 ? false : _props$muted,
    _props$level = props.level,
    level = _props$level === void 0 ? 4 : _props$level,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(SubSection, _extends({}, extra, {
    muted: muted
  }), /*#__PURE__*/_react["default"].createElement(SubSectionHeading, {
    level: level
  }, heading), content ? /*#__PURE__*/_react["default"].createElement(SubSectionContent, null, content) : null);
}